import React, { useEffect, useState } from "react";
import PageHeading from "../../CustomComponents/PageHeading";
import * as constants from "../../../constants";
import {
  IonButton,
  IonCol,
  IonImg,
  IonInput,
  IonLabel,
  IonModal,
  IonToast,
  isPlatform,
} from "@ionic/react";
import {
  COLLECTIONS,
  fireStoreDbInstance,
  getDocumentMetadata,
  getImageUrlFromFireStorage,
  getSubCollectionDocument,
  saveDocumentData,
  uploadImageToFireStorage,
} from "../../../firebase";
import { connect } from "react-redux";
import {
  updateUserDocuments,
  userDocuments,
  updateUserVehicleDocuments,
} from "../../../Store/Actions/userInfo";
// import { CustomIonImage } from "../../CustomComponents/IonImg";
import { Camera, CameraOptions } from "@ionic-native/camera";
import firebase from "firebase";
import { CustomIonImage } from "../../CustomComponents/IonImg";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { ToastMessage } from "../../../utils/toastMessage";
import moment from "moment";
import PreviewModal from "../../../utils/previewModal";
import { Loader } from "../../../utils/loader";
import { InAppBrowser } from "@ionic-native/in-app-browser";

const AddDocuments: React.FC = (props: any) => {
  const [state, setState] = useState<any>({});
  const [keys, setFieldKeys] = useState<any>({});
  const [showPicker, setPicker] = useState(false);
  const [isDisabled, setDisabled] = useState(false);
  const [loader, showLoader] = React.useState(false);
  const [fileType, setFileType] = useState<any>({
    frontDocumentImage: "",
    backDocumentImage: "",
  });
  const [preview, setPreview] = useState({
    showPreview: false,
    documentUrl: "",
  });
  const [date, setDate] = useState("");
  const days = ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"];
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  React.useEffect(() => {
    async function getData() {
      if (!!props.location.state) {
        const data = props.location.state.documentTemplate;
        const final: any =
          !!props.location.state &&
          Object.values(props.location.state.documentTemplate.additionalFieldsToCapture).reduce(
            (acc: any, ele: any) => {
              return {
                ...acc,
                ...{ [ele.fieldName]: !!ele.value ? ele.value : "" },
              };
            },
            {},
          );
        setState({
          ...final,
          frontDocumentImage: !!data.images ? data.images[0] : "",
          backDocumentImage: !!data.images ? data.images[1] : "",
          documentType: props.location.state.documentTemplate.name,
          did: Object.keys(props.location.state.documentTemplate).includes("did")
            ? props.location.state.documentTemplate.did
            : "",
        });
        if (!!(data.images || []).length) {
          setFileType({
            frontDocumentImage: await getMetaDataFromFirestore(data.images[0]),
            backDocumentImage: await getMetaDataFromFirestore(data.images[1]),
          });
        }
      }
    }
    getData();
    return () => {
      setState({
        data: {},
      });
      setFileType({
        frontDocumentImage: "",
        backDocumentImage: "",
      });
    };
  }, [props.location.state]);

  const [toast, setToast] = useState({
    showToast: false,
    toastMessage: "",
    severity: "",
  });

  const handleChange = (key: any, value: any) => {
    setState({
      ...state,
      [key]: value,
    });

    if (["frontDocumentImage", "backDocumentImage"].includes(key)) {
      setFileType({
        ...fileType,
        [key]: "",
      });
    }
  };

  const payloadBuilder = (obj: any) => {
    const keys: any = Object.keys(obj);
    const result: any = {};
    for (let i = 0; i < keys.length; i++) {
      if (obj.hasOwnProperty(keys[i]) && !!obj[keys[i]]) {
        result[keys[i]] = obj[keys[i]];
      }
    }
    return result;
  };

  const handleFileUpload = async (event: any, imageType: string) => {
    try {
      showLoader(true);
      const file = event.target.files[0];
      if (["application/pdf", "image/png", "image/jpg", "image/jpeg"].includes(file.type)) {
        const updatedFileName = `${file.name} ${Date.now()}`;
        const response: any = await uploadImageToFireStorage(
          props.uid,
          file,
          updatedFileName,
          "documents",
          file.type,
        );
        setState({
          ...state,
          [imageType]: response.snapshot.metadata.fullPath,
        });
        setFileType({
          ...fileType,
          [imageType]: response.snapshot.metadata.contentType,
        });
        showLoader(false);
      } else {
        throw Error(constants.PLEASE_UPLOAD_VALID_FORMAT);
      }
    } catch (e: any) {
      showLoader(false);
      setToast({
        showToast: true,
        toastMessage: e.message,
        severity: "warning",
      });
    }
  };

  const saveDocuments = async () => {
    try {
      const { additionalFieldsToCapture } = props.location.state.documentTemplate;
      Object.keys(state).find((ele: any) => {
        if (
          ele !== "expirationDate" &&
          !["did", "frontDocumentImage", "backDocumentImage"].includes(ele) &&
          !state[ele].trim().length
        ) {
          const key = additionalFieldsToCapture.find(
            (fieldName: any) => fieldName.fieldName === ele,
          ).fieldDisplayName;
          throw Error(`${key}${constants.IS_MANDATORY}`);
        }
        if (state.hasOwnProperty("expirationDate") && ele === "expirationDate" && !state[ele]) {
          throw Error("Please select expiry date");
        }
        if (!state[ele] && ele === "frontDocumentImage") {
          throw Error(constants.PLEASE_SELECT_IMAGE_DOCUMENT);
        }
        if (!state[ele] && ele === "backDocumentImage") {
          throw Error(constants.PLEASE_SELECT_BACK_IMAGE_DOCUMENT);
        }
      });
      setDisabled(true);
      const db = await fireStoreDbInstance();
      const vehicleData: any = await getSubCollectionDocument(
        props.uid,
        COLLECTIONS.USERS,
        COLLECTIONS.VECHICLES,
        props.location.state.vehicleId,
      );
      const {
        frontDocumentImage = "",
        backDocumentImage = "",
        expirationDate = "",
        documentId = "",
        documentType = "",
        did = "",
        ...rest
      } = state;

      const payload: any = {
        documentId: state.documentId,
        documentType: state.documentType,
        expirationDate: new Date(state.expirationDate).getTime(),
        additionalFields: {
          ...rest,
        },
        images: [state.frontDocumentImage, state.backDocumentImage],
      };
      const updatedPayload = payloadBuilder(payload);

      const id: any = await saveDocumentData(
        props.uid,
        updatedPayload,
        COLLECTIONS.USERS,
        COLLECTIONS.DOCUMENTS,
        state.did || "",
      );

      if (id.success) {
        setToast({
          showToast: true,
          toastMessage:
            `${props.location.state.documentTemplate.displayTitle}  ${constants.SAVED_SUCCESSFULLY}` ||
            `${constants.DOCUMENT} ${constants.SAVED_SUCCESSFULLY}`,
          severity: "success",
        });
      }
      !!did
        ? await props.updateUserDocuments({
            ...updatedPayload,
            did: state.did,
          })
        : await props.userDocuments([{ ...updatedPayload, did: id.did }]);
      !!!did &&
        (await saveDocumentData(
          props.uid,
          {
            ...vehicleData.data,
            documentIds: [
              ...vehicleData.data.documentIds,
              `users/${props.uid}/documents/${id.did}`,
            ],
            // documentIds: [
            //   ...vehicleData.data.documentIds,
            //   await db.doc(`users/${props.uid}/documents/${id.did}`),
            // ],
          },
          COLLECTIONS.USERS,
          COLLECTIONS.VECHICLES,
          props.location.state.vehicleId,
        ));
      !!!state.did &&
        (await props.updateUserVehicleDocuments(
          props.location.state.vehicleId,
          `users/${props.uid}/documents/${id.did}`,
        ));
      setTimeout(() => {
        props.history.goBack();
      }, 1000);
      setDisabled(true);
    } catch (e: any) {
      setToast({
        showToast: true,
        toastMessage: e.message,
        severity: "warning",
      });
    }
  };

  const options: CameraOptions = {
    destinationType: Camera.DestinationType.DATA_URL,
    sourceType: Camera.PictureSourceType.SAVEDPHOTOALBUM,
    mediaType: Camera.MediaType.ALLMEDIA,
  };

  const AccessNativeCamera = async (imageType: any) => {
    showLoader(true);
    Camera.getPicture(options).then(
      async (imageData) => {
        let base64Image = "data:image/jpeg;base64," + imageData;
        const res: any = await firebase
          .storage()
          .ref()
          .child(`${props.uid}/${"documents"}/${Date.now()}`)
          .putString(base64Image, "data_url", { contentType: "image/jpeg" })
          .then((snapshot) => {
            return snapshot.metadata.fullPath;
          });
        setState({
          ...state,
          [imageType]: res,
        });
        showLoader(false);
      },
      (err: any) => {
        console.error(err, "CamError");
        showLoader(false);
      },
    );
  };

  const getMetaDataFromFirestore = async (image: string) => {
    const result: any = await getDocumentMetadata(image);
    if (result.success) {
      return result.metadata.contentType;
    }
  };

  const openPdf = async (image: any) => {
    const imageUrl: any = await getImageUrlFromFireStorage(image);
    if (window.cordova) {
      const target = "_blank";
      const options =
        "location=no,clearcache=yes,hideurlbar=yes,hidenavigationbuttons=yes,cleardata=yes,toolbarposition=top";
      InAppBrowser.create(imageUrl.metadata, target, options);
    } else {
      setPreview({
        showPreview: true,
        documentUrl: imageUrl.metadata,
      });
    }
    // window.open(imageUrl.metadata);
  };

  return (
    <>
      <IonCol className="middle_panle" size-md="6">
        <div className="doc_vault_header">
          <PageHeading
            mainHeader={` Add ${props.location.state.documentTemplate.displayTitle}`}
            navigation={props}
            cssClass="background-for-forms"
          />
        </div>
        <div className="upload-document-main-div">
          <div className="upload-documents-div" style={{ marginTop: isPlatform("ios") ? 25 : 0 }}>
            {props.location.state.documentTemplate.supportsId === "true" && (
              <div className="documents-information-div">
                <IonLabel color="secondary" className="document-item-label">
                  {props.location.state.documentTemplate.idFieldDisplayName}
                </IonLabel>
                <IonInput
                  className="input-field uppercase border-radius-10"
                  color="tertiary"
                  placeholder={constants.PLEASE_ENTER_REGISTRATION_NUMBER}
                  value={state.documentId}
                  onIonChange={(event: any) => {
                    handleChange("documentId", event.detail.value);
                  }}
                />
              </div>
            )}

            {props.location.state.documentTemplate.additionalFieldsToCapture.map(
              (ele: any, index: any) =>
                ele.fieldName !== "documentId" &&
                ele.fieldName !== "expirationDate" && (
                  <div className="documents-information-div" key={index}>
                    <IonLabel color="secondary" className="document-item-label">
                      {ele.fieldDisplayName}
                    </IonLabel>
                    <IonInput
                      className="input-field uppercase border-radius-10"
                      color="tertiary"
                      placeholder={constants.ENTER_YOUR + ele.fieldDisplayName}
                      value={state[ele.fieldName]}
                      onIonChange={(event: any) => {
                        handleChange(ele.fieldName, event.detail.value);
                      }}
                    />
                  </div>
                ),
            )}
            {props.location.state.documentTemplate.supportsExpiration === "true" && (
              <div className="documents-information-div">
                <IonLabel color="secondary" className="document-item-label">
                  {constants.EXPIRY_DATE}
                </IonLabel>
                <div className="calender">
                  <IonInput
                    className="calender-input calender-item border-radius-10"
                    color="tertiary"
                    placeholder={constants.DATE}
                    readonly={true}
                    value={new Date(state.expirationDate).getDate() || ""}
                  />
                  <IonInput
                    className="calender-input calender-item border-radius-10"
                    color="tertiary"
                    placeholder={constants.MONTH}
                    readonly={true}
                    value={months[new Date(state.expirationDate).getMonth()] || ""}
                  />
                  <IonInput
                    className="calender-input calender-item border-radius-10"
                    color="tertiary"
                    placeholder={constants.YEAR}
                    readonly={true}
                    value={new Date(state.expirationDate).getFullYear() || ""}
                  />
                  <IonImg
                    className="calender-img"
                    src="/images/calendar1.svg"
                    alt="calendar"
                    onClick={() => setPicker(true)}
                  />
                </div>
              </div>
            )}
            <div className="documents-information-div">
              <IonLabel color="secondary" className="document-item-label">
                {constants.IMAGES}
              </IonLabel>
              <div className="upload-documents" style={{ justifyContent: "flex-start" }}>
                <div
                  className="upload-rc-documents res_doc"
                  style={{ marginRight: 10 }}
                  onClick={() =>
                    !!!state.frontDocumentImage && AccessNativeCamera("frontDocumentImage")
                  }
                >
                  {!!state.frontDocumentImage ? (
                    fileType.frontDocumentImage.includes("application/pdf") ? (
                      <IonLabel onClick={() => openPdf(state.frontDocumentImage)}>
                        {"pdf uploaded"}
                      </IonLabel>
                    ) : (
                      <CustomIonImage imgpath={state.frontDocumentImage} />
                    )
                  ) : (
                    <IonImg src={"/images/add.svg"} />
                  )}
                  {!!state.frontDocumentImage && (
                    <IonImg
                      src={"/images/close-icon.svg"}
                      className="document-remove-icon"
                      onClick={() => handleChange("frontDocumentImage", "")}
                    />
                  )}
                  {!!!state.frontDocumentImage && (
                    <IonLabel color="tertiary" className="upload-side">
                      {constants.UPLOAD_FRONT}
                    </IonLabel>
                  )}
                  {(isPlatform("desktop") || isPlatform("mobileweb")) &&
                    !!!state.frontDocumentImage && (
                      <input
                        type="file"
                        className="input_type_file"
                        accept=".png , .jpg, .pdf"
                        onChange={(event: any) => {
                          handleFileUpload(event, "frontDocumentImage");
                          event.target.value = null;
                        }}
                      />
                    )}
                </div>
                <div
                  className="upload-rc-documents res_doc"
                  style={{ marginRight: 10 }}
                  onClick={() =>
                    isPlatform("mobile") &&
                    !!!state.backDocumentImage &&
                    AccessNativeCamera("backDocumentImage")
                  }
                >
                  {" "}
                  {!!state.backDocumentImage ? (
                    fileType.backDocumentImage.includes("application/pdf") ? (
                      <IonLabel
                        onClick={() => openPdf(state.backDocumentImage)}
                        // onClick={() => window.open(state.backDocumentImage)}
                      >
                        {"pdf uploaded"}
                      </IonLabel>
                    ) : (
                      <CustomIonImage imgpath={state.backDocumentImage} />
                    )
                  ) : (
                    <IonImg src={"/images/add.svg"} />
                  )}
                  {!!state.backDocumentImage && (
                    <IonImg
                      src={"/images/close-icon.svg"}
                      className="document-remove-icon"
                      onClick={() => handleChange("backDocumentImage", "")}
                    />
                  )}
                  {!!!state.backDocumentImage && (
                    <IonLabel color="tertiary" className="upload-side">
                      {constants.UPLOAD_BACK}
                    </IonLabel>
                  )}
                  {(isPlatform("desktop") || isPlatform("mobileweb")) &&
                    !!!state.backDocumentImage && (
                      <input
                        type="file"
                        className="input_type_file"
                        accept=".png , .jpg, .pdf"
                        onChange={(event: any) => {
                          handleFileUpload(event, "backDocumentImage");
                          event.target.value = null;
                        }}
                      />
                    )}
                </div>
              </div>
              <IonLabel className="accepted-formats">{constants.FORMATS_ACCEPTED}</IonLabel>
            </div>
          </div>
        </div>
        <div
          className="btn_parent_div mg-top_50 page-footer-button"
          style={isPlatform("mobileweb") ? { marginBottom: 70 } : {}}
        >
          <IonButton
            className=" child_btn res_btn_align page-footer-save-button"
            color="primary"
            onClick={() => saveDocuments()}
            disabled={isDisabled}
          >
            <IonLabel color="customwhite">{constants.SAVE}</IonLabel>
          </IonButton>
        </div>
        <ToastMessage
          showToast={toast.showToast}
          ToastMessage={toast.toastMessage}
          severity={toast.severity}
          onDidDismiss={() => {
            setToast({
              showToast: false,
              toastMessage: "",
              severity: "",
            });
          }}
        />
        <IonModal
          isOpen={showPicker}
          backdropDismiss={true}
          onDidDismiss={() => {
            setPicker(false);
          }}
          cssClass="picker-modal"
        >
          <div className="picker-header">
            <IonLabel className="picker-header-year">
              {!!state.expirationDate
                ? new Date(state.expirationDate).getFullYear()
                : new Date().getFullYear()}
            </IonLabel>
            <div className="picker-header-month-date-div">
              <IonLabel className="picker-header-month-date">
                {!!state.expirationDate
                  ? days[new Date(state.expirationDate).getDay()]
                  : days[new Date().getDay()]}
                {","}{" "}
              </IonLabel>
              <IonLabel className="picker-header-month-date">
                {!!state.expirationDate
                  ? new Date(state.expirationDate).getDate()
                  : new Date().getDate()}
              </IonLabel>
              <IonLabel className="picker-header-month-date">
                {!!state.expirationDate
                  ? months[new Date(state.expirationDate).getMonth()]
                  : months[new Date().getMonth()]}
              </IonLabel>
            </div>
          </div>
          <Calendar
            onChange={(date: any) => {
              setDate(date);
              handleChange("expirationDate", date);
            }}
            value={!!state.expirationDate ? new Date(state.expirationDate) : new Date()}
          />
          <div className="picker-actions-div">
            <IonButton
              onClick={() => setPicker(false)}
              color="light"
              className="picker-action-buttons"
            >
              {constants.CANCEL}
            </IonButton>
            <IonButton
              color="light"
              className="picker-action-buttons"
              onClick={() => {
                handleChange("expirationDate", date);
                setPicker(false);
              }}
            >
              {constants.OK}
            </IonButton>
          </div>
        </IonModal>
        <PreviewModal
          showPreview={preview.showPreview}
          setShowPreview={(value: any) =>
            setPreview({
              showPreview: false,
              documentUrl: "",
            })
          }
          document={preview.documentUrl}
        />
        {loader ? <Loader loader={loader} /> : null}
      </IonCol>
    </>
  );
};

export default connect(
  ({ auth, userInfo: { userDocumentsList, userVehiclesList } }: any) => ({
    ...auth,
    userVehiclesList,
    userDocumentsList,
  }),
  { updateUserDocuments, userDocuments, updateUserVehicleDocuments },
)(AddDocuments);
